/**
 * ADM-678 (8ª iteración) — máscara de monto en bolívares para el campo editable
 * de los modales de pago (solo local/staging).
 *
 * El tester escribe solo dígitos y el campo se formatea mientras teclea tomando
 * los DOS últimos como decimales, en formato venezolano (`2.000,00`):
 *   "2"      → "0,02"
 *   "2000"   → "20,00"
 *   "200000" → "2.000,00"
 *
 * Lo que se muestra es el texto formateado; lo que viaja al API es el número
 * (`parseVesDisplay`). Borrar hasta vaciar deja el campo en blanco.
 */

/** Dígitos crudos → texto `1.234,56`. Vacío → ''. */
export function formatVesFromDigits(raw: string): string {
    const digits = (raw || '').replace(/\D/g, '').replace(/^0+(?=\d)/, '');
    if (!digits) return '';
    const cents = digits.padStart(3, '0');
    const intPart = cents.slice(0, -2);
    const decPart = cents.slice(-2);
    return `${intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${decPart}`;
}

/** Número → texto `1.234,56` (para precargar el campo). */
export function formatVesNumber(n: number): string {
    if (!Number.isFinite(n) || n <= 0) return '';
    return formatVesFromDigits(Math.round(n * 100).toString());
}

/** Texto `1.234,56` → 1234.56; `null` si está vacío o no es un monto > 0. */
export function parseVesDisplay(display: string): number | null {
    const normalized = (display || '').replace(/\./g, '').replace(',', '.').trim();
    if (!normalized) return null;
    const n = Number(normalized);
    return Number.isFinite(n) && n > 0 ? Number(n.toFixed(2)) : null;
}
